module.exports = __webpack_public_path__ + "img/sleeve cap front.cd16b85f.png";